var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("codemirror"), require("../addon/fold-code"), require("../addon/fold")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","codemirror","../addon/fold-code","../addon/fold"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldCodeWithWavedrom = this.HyperMD.FoldCodeWithWavedrom || {}), CodeMirror, HyperMD.FoldCode, HyperMD.Fold);
})(function (require, exports, CodeMirror, fold_code_1, fold_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaveDromRenderer = void 0;
    CodeMirror = __importStar(CodeMirror);
    exports.WaveDromRenderer = function (code, info) {
        var targetClass = info.changed
            ? "vickeymd-wavedrom-editor"
            : "vickymd-wavedrom-preview";
        var seq = document.getElementsByClassName(targetClass).length; // Math.round(1e9 * Math.random()) + Date.now();
        var id = targetClass + seq;
        var el = document.createElement("div");
        el.id = id;
        el.classList.add(targetClass);
        el.style.margin = "8px";
        var json = {};
        try {
            json = JSON.parse(code);
        }
        catch (error) {
            el.innerText = error.toString();
            return {
                element: el,
                asyncRenderer: null
            };
        }
        var asyncRenderer = function () {
            try {
                // document.body.append(el); // HACK: Have to append to body first
                el.textContent = code;
                window["WaveDrom"].RenderWaveForm(seq, json, targetClass);
            }
            catch (error) {
                el.innerText = "Failed to eval WaveDrom code. " + error;
            }
        };
        return {
            element: el,
            asyncRenderer: asyncRenderer
        };
    };
    if (window["WaveDrom"]) {
        CodeMirror.defineOption("wavedrom", null, function (cm) {
            fold_code_1.getAddon(cm).clear("wavedrom");
            fold_1.getAddon(cm).startFold();
        });
        fold_code_1.registerRenderer({
            name: "wavedrom",
            pattern: /^wavedrom$/i,
            renderer: exports.WaveDromRenderer,
            suggested: true
        });
        if (window["VICKYMD_DEBUG"]) {
            console.log("[HyperMD] PowerPack fold-code-with-wavedrom loaded.");
        }
    }
    else {
        if (window["VICKYMD_DEBUG"]) {
            console.log("[HyperMD] PowerPack fold-code-with-wavedrom failed to load.\nPlease include  \n\n  <script src=\"https://cdnjs.cloudflare.com/ajax/libs/wavedrom/2.1.2/skins/default.js\" type=\"text/javascript\"></script>\n  <script src=\"https://cdnjs.cloudflare.com/ajax/libs/wavedrom/2.1.2/wavedrom.min.js\" type=\"text/javascript\"></script>\n\nin your HTML file");
        }
    }
});
/*
Example:

```wavedrom
{"signal":[{"name":"clk","wave":"p...."},{"name":"Data","wave":"x345x","data":["head","body","tail"]},{"name":"Request","wave":"01..0"}],"config":{"hscale":1}}
```

*/
